import { LanguagesService } from '@alpha-core/platform-ui';
import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { escapeRegExp } from 'lodash-es';
import { DndDraggableDirective, DndDropEvent, DndDropzoneDirective, DndPlaceholderRefDirective } from 'ngx-drag-drop';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../shared/alpha-shared.module';

interface ColumnConfig {
    hideable: boolean;
    sort: boolean;
    name: string;
    label: string;
    labelType: string | null;
    mapping: string;
    mappingType: string;
    type: string;
    dateTimeFormat: string | null;
    translatedLabel?: string;
}
@Component({
    selector: 'app-inbox-columns',
    standalone: true,
    templateUrl: './inbox-columns.component.html',
    imports: [
        PrimeNGModules,
        DndDraggableDirective,
        DndDropzoneDirective,
        DndPlaceholderRefDirective,
        DndDraggableDirective,
        TranslatePipe,
    ],
})
export class InboxColumnsComponent implements OnChanges {
    @Input() currentTask: any;
    @Output() arrayEmitter = new EventEmitter<any[]>();
    columnArray: ColumnConfig[] = [];
    selectedCount: number = 0;
    isActive: any;
    columns: ColumnConfig[] = [];
    searchValue: string = '';

    languageService = inject(LanguagesService);

    constructor() {
        this.languageService.selectedLanguage$.pipe(takeUntilDestroyed()).subscribe(() => {
            this.getColumns(this.searchValue);
            this.getSelectedColumnsCount();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['currentTask'] && changes['currentTask'].currentValue.columns) {
            this.columnArray = structuredClone(changes['currentTask'].currentValue.columns);
            this.getColumns('');
            this.getSelectedColumnsCount();
        }
    }

    ClearAll() {
        this.columnArray.map((column) => (column.hideable = true));
        this.selectedCount = 0;
    }

    selectCheckboxes(column: ColumnConfig) {
        if (column) {
            column.hideable = !column.hideable;
        }
        if (column.hideable) {
            this.selectedCount--;
        } else {
            this.selectedCount++;
        }
    }

    //! Gets the count of the selected columns
    getSelectedColumnsCount() {
        this.selectedCount = this.columnArray?.filter((col) => !col.hideable).length || 0;
    }

    onDrop(event: DndDropEvent, list: any[]) {
        let index = event.index;
        if (typeof index === 'undefined') {
            index = list.length;
        }
        list.splice(index, 0, event.data);
    }

    onDragged(item: any, list: any[]) {
        const index = list.indexOf(item);
        list.splice(index, 1);
    }

    // This function used for column filter based on user column config

    applyColumn(event: Event, element: any) {
        this.arrayEmitter.emit(this.deepCopy(this.columnArray));
        this.columns = this.columnArray;
        this.searchValue = '';
        element.hide(event);
    }

    deepCopy<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj)) as T;
    }

    //! This provides datasource
    getColumns(value: string) {
        const filteredColumns = this.getFilteredColumns(value);
        filteredColumns.forEach((col) => (col['translatedLabel'] = this.languageService.translateConfig(col.label)));
        this.columns = filteredColumns;
    }

    private getFilteredColumns(value: string) {
        if (!value || !value.length) {
            return this.columnArray;
        }
        this.searchValue = value.toLowerCase()?.trim();
        const regex = new RegExp(escapeRegExp(this.searchValue), 'i');
        return this.columnArray.filter((col: any) => {
            if (col?.['translatedLabel']) {
                return regex.test(col?.['translatedLabel']?.toLowerCase()?.trim());
            }
            return regex.test(col?.label?.toLowerCase()?.trim());
        });
    }

    clearInput(input?: HTMLInputElement) {
        if (input) input.value = '';
        this.searchValue = '';
        this.getColumns(''); // Clear the search results as well
    }
}
